import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style, styleVariants } from '@vanilla-extract/css';

export const stepperContainer = style({
  display: 'flex',
  width: '100%',
});

export const stepperContainerVariants = styleVariants({
  default: {},
  input: {
    height: 32,
    borderRadius: borderRadius.r8,
    outline: `1px solid ${themeVars.controls.border.default}`,
    outlineOffset: -1,
    backgroundColor: themeVars.controls.background.default,
    color: themeVars.controls.foreground.input,
    ':hover': {
      outlineColor: themeVars.controls.border.hover,
    },
    ':focus-within': {
      outlineColor: themeVars.controls.border.active,
    },
  },
});

export const rightButton = style({
  borderTopRightRadius: borderRadius.r8,
  borderBottomRightRadius: borderRadius.r8,
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
});

export const leftButton = style({
  borderTopLeftRadius: borderRadius.r8,
  borderBottomLeftRadius: borderRadius.r8,
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
});

export const stepperBody = style([
  typography.labelMd,
  {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    width: '100%',
    minWidth: 0,
    padding: 0,
  },
]);

export const stepperBodyVariants = styleVariants({
  default: {
    borderRight: `1px solid ${themeVars.container.primary.background.idle}`,
    borderLeft: `1px solid ${themeVars.container.primary.background.idle}`,
    background: themeVars.button.secondary.background.idle,
    color: themeVars.button.secondary.foreground,
  },
  input: {
    background: 'transparent',
    color: 'inherit',
    justifyContent: 'center',
    gap: space.s2,
  },
});

export const stepperInput = style({
  padding: 0,
  background: 'transparent',
  border: 0,
  color: 'inherit',
  font: 'inherit',
  outline: 'none',
  appearance: 'none',
  WebkitAppearance: 'none',
  MozAppearance: 'textfield',
  ':focus': {
    outline: 'none',
  },
  ':focus-visible': {
    outline: 'none',
  },
  '::placeholder': {
    color: themeVars.controls.foreground.default,
  },
});

export const stepperInputVariants = styleVariants({
  default: {
    flexGrow: 1,
    width: '100%',
    minWidth: 0,
    textAlign: 'center',
  },
  input: {
    flexGrow: 0,
    width: 'auto',
    minWidth: '1ch',
    textAlign: 'center',
    fontWeight: 600,
  },
});

export const stepperSuffix = style({
  flexShrink: 0,
  color: 'inherit',
});

export type StepperVariant = keyof typeof stepperContainerVariants;
